import React, { useState } from 'react'
import styles from './header_.module.css'
import strings from '../../../src/strings/strings.json'
import { useRouter } from 'next/router'

export default function BtnLogout(props) {

    const router = useRouter()
    const [open, setOpen] = useState(false)

    const renderItem = (icon, txt, color) => {
        return (
            <div className="flex flex_start">
                <img src={`/assets/icons/${icon}.svg`} alt="Icon" />
                <span className={`${styles.menu_item_text} ${color ? styles.exit_text_color : null}`}>{txt}</span>
            </div>
        )
    }
    return (
        <button className={styles.login_btn} onClick={props.onClickHandler} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
            <img className="pl-2" src="/assets/icons/user.svg" alt="Icon" />
            <span className={`${styles.login_out_text} primary_color`}>{props.user.first_name} {props.user.last_name}</span>
            <img className={!open ? styles.rotate_arrow : null} src="/assets/icons/arrow-down-s-line.svg" alt="Icon" />
            <div className={styles.info_container_content} style={open ? { display: "block" } : { display: "none" }}>
                <div className={styles.item_container}>
                    <div className={`${styles.changePass} primary_color`} onClick={() => router.push('/user/dashboard')}>{renderItem('dashboard-line', strings.general_userPanel, null)}</div>
                    <div className={`${styles.changePass} ${styles.divider} primary_color`} onClick={() => router.push('/change-password')}>{renderItem('rotate-lock-fill', strings.general_changePass, null)}</div>
                    <div className={`${styles.changePass} primary_color`} onClick={() => props.logoutHandler()}>{renderItem('logout-box-line', strings.login_exit, '#e6185c')}</div>
                </div>
            </div>
        </button >
    )
}
